import * as STATE from './states';
export const COMMENT_STATE = STATE;
export { default } from './DetailedComment';
